function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from "react";
import PropTypes from "prop-types";
import logger from "../../logger";
import { AdobeTarget } from "../AdobeTarget/AdobeTarget";
import useRemoteModule from "../../hooks/useRemoteModule";
import { FOOCMask } from "../utilities/FOOCMask";
// Added imports for cachev2 feature test
import { DynamicTestWrapper } from "../DynamicTestWrapper";
import { getFlag, getPersonalizationClientId } from "../../utils/ld-cache";
import useURL from "../../hooks/useURL";
var ABTestWrapper = /*#__PURE__*/ forwardRef(function ABTestWrapper(props, ref) {
    var name = props.name, _props_children = props.children, children = _props_children === void 0 ? null : _props_children;
    // TODO: Look at using launch darkly to get the ABT config in addition to federation
    var abtConfig = useRemoteModule({
        remote: "abtFederationHost",
        module: "mboxConfigs"
    });
    var hide = !abtConfig;
    var _useMemo = _sliced_to_array(useMemo(function() {
        var p = _extends({
            disableFoocMask: false
        }, props);
        try {
            var _abtConfig, _abtConfig1;
            if (((_abtConfig = abtConfig) == null ? void 0 : _abtConfig.default) && typeof ((_abtConfig1 = abtConfig) == null ? void 0 : _abtConfig1.default) === "function") {
                p = _extends({}, abtConfig.default(name, p, props, false));
            } else {
                logger.warn("ABTestWrapper Remote config does not export a default function, remote config was skipped.");
            }
        } catch (error) {
            logger.error("Error while trying to apply remote config for mobx: '" + name + "'", error);
        }
        var abTestEndDate = p.abTestEndDate;
        var expiredDate = Date.parse(abTestEndDate);
        if (Number.isNaN(expiredDate) || expiredDate < Date.now()) {
            // Disable testing
            return [
                null,
                p
            ];
        }
        return [
            AdobeTarget,
            p
        ];
    }, [
        abtConfig,
        name,
        props
    ]), 2), ConfiguredComponent = _useMemo[0], remoteProps = _useMemo[1];
    return /*#__PURE__*/ _jsx(FOOCMask, {
        hide: hide,
        children: ConfiguredComponent && hide === false ? /*#__PURE__*/ _jsx(ConfiguredComponent, _extends({}, remoteProps, {
            ref: ref
        })) : children
    });
});
ABTestWrapper.propTypes = {
    abTestEndDate: PropTypes.string.isRequired
};
var ABTestWrapperWithDynamic = /*#__PURE__*/ forwardRef(function ABTestWrapperWithDynamic(props, ref) {
    // Using getFlag instead of useLaunchDarklyFlag to avoid adding anything to the cache
    // We only want to do this if the flag came from server side rendering
    var useNewCache = getFlag("replace-lapel-legacy-cache", false, getPersonalizationClientId());
    var url = useURL();
    var name = props.name, parameters = props.parameters, profileParameters = props.profileParameters, disableFoocMask = props.disableFoocMask;
    var entryConfig = useMemo(function() {
        return {
            name: name,
            parameters: parameters,
            profileParameters: profileParameters,
            path: url
        };
    }, [
        name,
        parameters,
        profileParameters,
        url
    ]);
    if (useNewCache) {
        return /*#__PURE__*/ _jsx(DynamicTestWrapper, _extends({}, props, {
            config: entryConfig,
            ref: ref,
            foocMask: !disableFoocMask
        }));
    }
    return /*#__PURE__*/ _jsx(ABTestWrapper, _extends({}, props, {
        ref: ref
    }));
});
export { ABTestWrapperWithDynamic as ABTestWrapper };

//# sourceMappingURL=ABTestWrapper.js.map